import axios from 'axios'
import helper from '../helper'

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL

const qrcodeEndpoint = 'api/v1/qrcodes/settings'

export const serviceSettingQR = {
  get: (token, params) => helper.get(qrcodeEndpoint, token, params),
  post: (token, { form }) => helper.post(qrcodeEndpoint, form, token),
  uploadLogo: (token, { data, settingQrcodeId }) =>
    helper.patch(`${qrcodeEndpoint}/${settingQrcodeId}/upload`, data, token),
  update: (token, { settingQrcodeId, data }) =>
    helper.patch(`${qrcodeEndpoint}/${settingQrcodeId}`, data, token),
  delete: (token, { settingID }) =>
    axios
      .delete(apiBaseUrl + `${qrcodeEndpoint}/${settingID}`, {
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      .catch((err) => err.response)
}
